(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wees-delivery-checker"] && !Shopify.designMode) return;
  try {
    (()=>{const initialize=()=>document.querySelectorAll('[data-delivery-checker]').forEach(hub=>{if(hub.dataset.initialized)return;hub.dataset.initialized='true';
    const locationInput = hub.querySelector('#wba-location');
    const checkButton = hub.querySelector('[data-check-location]');
    const result = hub.querySelector('[data-checker-result]');
    const deliveryResult = (hub.closest('[data-business-hub]') || hub).querySelector('[data-delivery-result]');
    const deliveryZip = (hub.closest('[data-business-hub]') || hub).querySelector('[data-delivery-zip]');
    const deliveryDistance = (hub.closest('[data-business-hub]') || hub).querySelector('[data-delivery-distance]');
    const deliveryQualification = (hub.closest('[data-business-hub]') || hub).querySelector('[data-delivery-qualification]');
    const resultHeading = result.querySelector('[data-result-heading]');
    const resultMessage = result.querySelector('[data-result-message]');
    const resultMeta = result.querySelector('[data-result-meta]');
    const resultZip = result.querySelector('[data-result-zip]');
    const resultDistance = result.querySelector('[data-result-distance]');
    const resultQualification = result.querySelector('[data-result-qualification]');
    const resultIcon = result.querySelector('[data-result-icon]');
    const resultAction = result.querySelector('[data-result-action]');
    let origin, policy;
    let zipDataPromise;
    const radians = (degrees) => degrees * Math.PI / 180;
    const distanceMiles = (latitude, longitude) => {
      const latitudeDelta = radians(latitude - origin[0]);
      const longitudeDelta = radians(longitude - origin[1]);
      const a = Math.sin(latitudeDelta / 2) ** 2 + Math.cos(radians(origin[0])) * Math.cos(radians(latitude)) * Math.sin(longitudeDelta / 2) ** 2;
      return policy.earthRadiusMiles * 2 * Math.asin(Math.sqrt(a));
    };
    const loadZipData = () => {
      if (!zipDataPromise) zipDataPromise = Promise.all([hub.dataset.zipAsset,hub.dataset.policyAsset].map(url => fetch(url,{credentials:'same-origin'}).then(response => {if(!response.ok) throw new Error('Lookup unavailable');return response.json();}))).then(([data,rules])=>{origin=[data.metadata.origin.lat,data.metadata.origin.lon];policy=rules;return data;}).catch(error=>{zipDataPromise=null;throw error;});
      return zipDataPromise;
    };
    const showZipResult = ({title, copy, state, icon, action, zip, miles}) => {
      const hasDistance = zip && Number.isFinite(miles);
      result.className = `wba-result wba-result--${state}`;
      resultHeading.textContent = title;
      resultMessage.textContent = copy;
      resultIcon.textContent = icon;
      resultAction.textContent = action;
      resultMeta.hidden = !zip;
      resultZip.textContent = zip || '';
      resultDistance.parentElement.hidden = !hasDistance;
      resultDistance.textContent = hasDistance ? `${miles.toFixed(1)} miles` : '';
      resultQualification.hidden = !hasDistance;
      if (deliveryResult) deliveryResult.value = title;
      if (deliveryZip) deliveryZip.value = zip || '';
      if (deliveryDistance) deliveryDistance.value = hasDistance ? `${miles.toFixed(1)} miles` : '';
      if (deliveryQualification) deliveryQualification.value = 'Exact-address and operational confirmation required';
      resultHeading.focus({preventScroll:true});
    };
    const checkZip = async () => {
      if(checkButton.disabled) return;
      const zip = locationInput.value.trim();
      checkButton.disabled = true;
      checkButton.textContent = 'Checking…';
      try {
        if (!/^\d{5}$/.test(zip)) throw new Error('invalid');
        const data = await loadZipData();
        const centroid = data.zips[zip];
        if (!centroid) throw new Error('missing');
        const miles = distanceMiles(centroid[0], centroid[1]);
        if (miles <= policy.eligibleMiles) showZipResult({title:'Local Delivery Likely Available',copy:'This ZIP code appears to fall within the Wees Express local delivery area.',state:'eligible',icon:'✓',action:'Continue Your Business Account Application',zip,miles});
        else if (miles <= policy.reviewMiles) showZipResult({title:'Manual Review Required',copy:'This ZIP code is near the edge of the Wees Express local delivery area. Submit the business account application and the team will confirm availability for the exact address.',state:'review',icon:'!',action:'Continue Your Business Account Application',zip,miles});
        else showZipResult({title:'Nationwide Business Account Available',copy:'This ZIP code appears to be outside the current local delivery area. Your business can still open a Wees Express account and order eligible products for nationwide shipping.',state:'nationwide',icon:'i',action:'Continue Your Business Account Application',zip,miles});
      } catch (error) {
        showZipResult({title:'ZIP Code Could Not Be Verified',copy:'Enter a valid five-digit ZIP code or continue with the application and the Wees Express team will review your location.',state:'invalid',icon:'!',action:'Continue to Application',zip:/^\d{5}$/.test(zip) ? zip : ''});
      } finally {
        checkButton.disabled = false;
        checkButton.textContent = 'Check ZIP Code';
      }
    };
    checkButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      checkZip();
    }, true);
    locationInput.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        checkZip();
      }
    });

});initialize();document.addEventListener('shopify:section:load',initialize);})();
  } catch(e) { console.error(e); }
})();

})();
